import con from "../../../connection";
var path = '/idms';
var idms = function (url) { return function (version) { return ({
    get: function () { return con.getFile(url + path + "/" + version, {}); }
}); }; };
export default idms;
